import { Link } from "react-router-dom";

/**
 * Client-side unmatched-route screen (ROUTE-INTEGRITY-404-A1).
 * Does not change HTTP status of the SPA document response.
 * Known-route entity/API 404s remain owned by their existing screens.
 */
function NotFoundScreen() {
  return (
    <main className="not-found-section" id="not-found-layout">
      <section
        className="not-found-section__panel"
        id="Csection"
        aria-labelledby="not-found-heading"
        tabIndex="-1"
      >
        <div className="container">
          <div className="ui-empty ui-empty--lg not-found-screen">
            <span className="ui-empty__icon" aria-hidden="true">
              <i className="fa-solid fa-compass" />
            </span>
            <h1 id="not-found-heading" className="ui-empty__title">
              Сторінку не знайдено
            </h1>
            <p className="ui-empty__description">
              Можливо, адреса вказана неправильно або сторінка більше недоступна.
            </p>
            <div className="ui-empty__actions">
              <Link to="/" className="action-btn not-found-screen__home">
                На головну
              </Link>
              <Link to="/search" className="action-btn not-found-screen__search">
                До пошуку
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NotFoundScreen;
